<template>
    <div class="row" :class="{ blink: updateMode }" style="padding-top: 5px">
        <div class="col-lg-6">
            <ProductSearchBox
                ref="productSearchBox"
                :mode="this.mode"
                @returnData="doStuff"
            />
        </div>
        <div class="col-lg-6">
            <slot></slot>
        </div>
        <div v-if="!updateMode">
            <button class="btn btn-primary" style="width: 200px;margin-top: 10px" @click="getFocus">
                {{ $t('common_add') }}
            </button>
        </div>
        <div v-if="updateMode">
            <div class="row">
                <div class="col-6">
                    <p class="btn btn-warning" style="width: 200px;margin-top: 10px" @click="cancelUpdate">
                        {{ $t('common_cancel') }}
                    </p>
                </div>
                <div class="col-6">
                    <button class="btn btn-success" style="width: 200px;margin-top: 10px">
                        {{ $t('common_update') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProductSearchBox from "@/components/ProductSearchBox";

export default {
    name: "FilterDetailContentBox",
    components: {
        ProductSearchBox
    },
    props:{
        mode: '',
        updateMode: '',
    },
    data(){
        return{
            ctnQty: '',
            getComponentProduct: '',
        }
    },
    methods: {
        doStuff(data){
            this.$emit('returnProductData', data)
        },
        getFocus(){
            this.$refs.productSearchBox.focusOnSelectBox()
        },
        resetProductSearch(){
            this.$refs.productSearchBox.resetThisProductSearchBox()
        },
        cancelUpdate(){
            this.$emit('cancelUpdateMode', false)
        },
        updateModeChange(value){
            this.$refs.productSearchBox.updateMode(value)
        },
    }
}
</script>

<style scoped>
.blink{
    animation: blink 1s infinite;
}

@keyframes blink{
    0% {
        background: white;
    }
    50%{
        background: #77ff77;
    }
    100% {
        background: white;
    }
}

@-webkit-keyframes blink{
    0% {
        background: white;
    }
    50%{
        background: #77ff77;
    }
    100% {
        background: white;
    }
}
</style>
